import { Record } from "../fable_modules/fable-library-js.4.29.0/Types.js";
import { Task_$reflection, EnrolledTrack_$reflection } from "../Shared/SharedModels.jsx";
import { record_type, bool_type, option_type, lambda_type, unit_type, array_type } from "../fable_modules/fable-library-js.4.29.0/Reflection.js";
import { mapIndexed, sortBy, map, collect, append, tryFind } from "../fable_modules/fable-library-js.4.29.0/Array.js";
import { Array_distinct } from "../fable_modules/fable-library-js.4.29.0/Seq2.js";
import { comparePrimitives, createObj, safeHash, equals } from "../fable_modules/fable-library-js.4.29.0/Util.js";
import { createElement } from "react";
import React from "react";
import { ScreenSize, useFeliz_React__React_useResponsive_Static_Z434A9929 } from "../fable_modules/Feliz.UseMediaQuery.1.5.0/UseMediaQuery.fs.js";
import { exists, iterate, tryHead, empty, singleton, append as append_1, delay, toList } from "../fable_modules/fable-library-js.4.29.0/Seq.js";
import { AccordionPanel, AccordionHeader, AccordionItem, Accordion, Body1, Checkbox, Link, Tooltip, CardFooter, Caption1, Badge, CardHeader, tokens, Card, Caption2, Body1Strong, InfoLabel } from "@fluentui/react-components";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { singleton as singleton_1, empty as empty_1, ofArray } from "../fable_modules/fable-library-js.4.29.0/List.js";
import { unwrap, toArray, defaultArg } from "../fable_modules/fable-library-js.4.29.0/Option.js";
import { LockClosedRegular, CheckmarkCircleFilled, CircleHintHalfVerticalFilled, CircleRegular, CheckmarkCircleRegular, OpenRegular, BookOpenRegular } from "@fluentui/react-icons";
import { RouterModule_encodeParts } from "../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { reactApi as reactApi_1 } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { defaultOf } from "../fable_modules/fable-library-js.4.29.0/Util.js";
import { Checkbox_toBool } from "../fable_modules/FS.FluentUI.3.0.0/Domain.fs.js";

export class TrackProgressProps extends Record {
    constructor(Track, CompletedTasks, OnTaskComplete, OnTaskRevoke, IsInactive) {
        super();
        this.Track = Track;
        this.CompletedTasks = CompletedTasks;
        this.OnTaskComplete = OnTaskComplete;
        this.OnTaskRevoke = OnTaskRevoke;
        this.IsInactive = IsInactive;
    }
}

export function TrackProgressProps_$reflection() {
    return record_type("Track.TrackProgress.TrackProgressProps", [], TrackProgressProps, () => [["Track", EnrolledTrack_$reflection()], ["CompletedTasks", array_type(Task_$reflection())], ["OnTaskComplete", option_type(lambda_type(Task_$reflection(), unit_type))], ["OnTaskRevoke", option_type(lambda_type(Task_$reflection(), unit_type))], ["IsInactive", bool_type]]);
}

function getCurrentLevel(track, currentLevelId) {
    return tryFind((l) => (l.Id === currentLevelId), track.TrackLevels);
}

function getTasksInLevel(level) {
    return Array_distinct(append(collect((_arg) => _arg.Course.Tasks, level.TrackLevelCourses), level.Tasks), {
        Equals: equals,
        GetHashCode: safeHash,
    });
}

function isTaskCompleted(task, completedTasks) {
    return completedTasks.some((t) => (t.Id === task.Id));
}

function isLevelCompleted(level, completedTasks) {
    const tasks = getTasksInLevel(level);
    if (tasks.length > 0) {
        return tasks.every((t) => isTaskCompleted(t, completedTasks));
    }
    else {
        return false;
    }
}

function customDivider(color) {
    return createElement("div", {
        style: {
            width: 1,
            backgroundColor: color,
            flexGrow: 1,
            display: "flex",
        },
    });
}

function LevelContent(levelContentInputProps) {
    let elems_8;
    const onTaskRevoke = levelContentInputProps.onTaskRevoke;
    const onTaskComplete = levelContentInputProps.onTaskComplete;
    const isInactive = levelContentInputProps.isInactive;
    const currentLevel = levelContentInputProps.currentLevel;
    const completedTasks = levelContentInputProps.completedTasks;
    const level = levelContentInputProps.level;
    const screenSize = useFeliz_React__React_useResponsive_Static_Z434A9929();
    const isMobile = equals(screenSize, new ScreenSize(0, [])) ? true : equals(screenSize, new ScreenSize(1, []));
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 5 + "px ",
        paddingBottom: 15,
    }], (elems_8 = toList(delay(() => {
        let el_4;
        return append_1((level.RequiredTasks.length > 0) ? singleton((el_4 = InfoLabel, createElement(el_4, createObj(toList(delay(() => append_1((level.RequiredTasks.length === 1) ? singleton(["children", `${level.RequiredTasks.length} betingelse`]) : singleton(["children", `${level.RequiredTasks.length} betingelser`]), delay(() => {
            let elems;
            return append_1(singleton(["info", createElement("div", createObj(ofArray([["style", {
                display: "flex",
                flexDirection: "column",
            }], (elems = toList(delay(() => {
                let el;
                return append_1(singleton((el = Body1Strong, createElement(el, {
                    children: `Dette nivået krever ${level.RequiredTasks.length} betingelser`,
                }))), delay(() => map((rt) => {
                    const el_2 = Caption2;
                    return createElement(el_2, {
                        children: rt.Name,
                    });
                }, sortBy((_arg) => _arg.Name, level.RequiredTasks, {
                    Compare: comparePrimitives,
                }))));
            })), ["children", reactApi.Children.toArray(Array.from(elems))])])))]), delay(() => singleton(["weight", "regular"])));
        })))))))) : empty(), delay(() => append_1(map((tlc) => {
            let elems_6;
            const hasTakenAllTasks = tlc.Course.Tasks.every((t) => isTaskCompleted(t, completedTasks));
            const totalTakenInCourse = tlc.Course.Tasks.filter((t_1) => isTaskCompleted(t_1, completedTasks));
            const descriptionText = defaultArg(tlc.Course.Description, "");
            const el_29 = Card;
            return createElement(el_29, createObj(ofArray([["appearance", "filled"], ["orientation", "horizontal"], (elems_6 = toList(delay(() => {
                let el_6;
                return append_1(singleton((el_6 = BookOpenRegular, createElement(el_6, createObj(toList(delay(() => append_1(singleton(["fontSize", 20]), delay(() => ((hasTakenAllTasks && (currentLevel != null)) ? singleton(["primaryFill", tokens.colorStatusSuccessBorderActive]) : empty()))))))))), delay(() => {
                    let el_16, el_8, elems_2;
                    return append_1(singleton((el_16 = CardHeader, createElement(el_16, {
                        header: (el_8 = Body1Strong, createElement(el_8, {
                            children: tlc.Course.Name,
                        })),
                        description: createElement("div", createObj(ofArray([["style", {
                            display: "flex",
                            flexDirection: "column",
                            gap: 4 + "px ",
                        }], (elems_2 = toList(delay(() => {
                            let elems_1, el_10, el_12;
                            return append_1(singleton(createElement("div", createObj(ofArray([["style", {
                                display: "flex",
                                gap: 5 + "px ",
                            }], (elems_1 = [(el_10 = Badge, createElement(el_10, {
                                color: "informative",
                                size: "small",
                                children: "Kurs",
                            })), (el_12 = Badge, createElement(el_12, createObj(toList(delay(() => append_1((hasTakenAllTasks && (currentLevel != null)) ? singleton(["color", "success"]) : singleton(["color", "informative"]), delay(() => append_1(singleton(["size", "small"]), delay(() => append_1(singleton(["shape", "circular"]), delay(() => append_1(singleton(["appearance", "tint"]), delay(() => singleton(["children", `${totalTakenInCourse.length}/${tlc.Course.Tasks.length}`]))))))))))))))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
                                let el_14;
                                return (isMobile && (descriptionText.length > 0)) ? singleton((el_14 = Caption1, createElement(el_14, {
                                    style: {
                                        color: tokens.colorNeutralForeground3,
                                    },
                                    children: descriptionText,
                                }))) : empty();
                            }));
                        })), ["children", reactApi.Children.toArray(Array.from(elems_2))])]))),
                    }))), delay(() => {
                        let elems_3, el_18;
                        return append_1(!isMobile ? singleton(createElement("div", createObj(ofArray([["style", {
                            display: "flex",
                            flexDirection: "column",
                            width: 80 + "%",
                            alignItems: "center",
                        }], (elems_3 = [(el_18 = Caption1, createElement(el_18, {
                            children: descriptionText,
                        }))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))) : empty(), delay(() => {
                            let el_27, el_25, matchValue, el_22, elems_4, el_20;
                            return singleton((el_27 = CardFooter, createElement(el_27, {
                                action: (el_25 = Tooltip, createElement(el_25, createObj(ofArray([["content", "Vis detaljer"], (matchValue = tryHead([(el_22 = Link, createElement(el_22, createObj(ofArray([["href", RouterModule_encodeParts(ofArray(["kurs", `${tlc.Course.Id}`]), 1)], (elems_4 = [(el_20 = OpenRegular, createElement(el_20, {
                                    fontSize: 16,
                                }))], ["children", reactApi_1.Children.toArray(Array.from(elems_4))])]))))]), (matchValue == null) ? ["children", defaultOf()] : ["children", matchValue])])))),
                            })));
                        }));
                    }));
                }));
            })), ["children", reactApi_1.Children.toArray(Array.from(elems_6))])])));
        }, level.TrackLevelCourses), delay(() => map((task) => {
            let elems_7;
            const hasTakenThisTask = isTaskCompleted(task, completedTasks);
            const canSelfReport = ((onTaskComplete != null) ? true : (onTaskRevoke != null)) && !isInactive;
            const el_45 = Card;
            return createElement(el_45, createObj(ofArray([["size", "small"], ["appearance", "filled"], ["orientation", "horizontal"], (elems_7 = toList(delay(() => {
                let el_31, el_33, el_35, el_37;
                return append_1(((hasTakenThisTask && canSelfReport) && (onTaskRevoke != null)) ? singleton((el_31 = Checkbox, createElement(el_31, {
                    checked: true,
                    onChange: (_arg_2, c) => {
                        const _arg_1 = Checkbox_toBool(c);
                        iterate((f) => {
                            f(task);
                        }, toArray(onTaskRevoke));
                    },
                }))) : (hasTakenThisTask ? singleton((el_33 = CheckmarkCircleRegular, createElement(el_33, {
                    fontSize: 20,
                    primaryFill: tokens.colorStatusSuccessBorderActive,
                }))) : (((canSelfReport && (onTaskComplete != null)) && !task.VerificationRequired) ? singleton((el_35 = Checkbox, createElement(el_35, {
                    checked: false,
                    onChange: (_arg_4, c_1) => {
                        const _arg_3 = Checkbox_toBool(c_1);
                        iterate((f_1) => {
                            f_1(task);
                        }, toArray(onTaskComplete));
                    },
                }))) : singleton((el_37 = CircleRegular, createElement(el_37, {
                    fontSize: 20,
                    primaryFill: tokens.colorNeutralStroke1,
                }))))), delay(() => {
                    let el_43, el_39, el_41;
                    return singleton((el_43 = CardHeader, createElement(el_43, {
                        header: (el_39 = Body1, createElement(el_39, {
                            children: task.Name,
                        })),
                        description: (el_41 = Badge, createElement(el_41, createObj(toList(delay(() => append_1(singleton(["color", "informative"]), delay(() => append_1(singleton(["size", "small"]), delay(() => (task.VerificationRequired ? singleton(["children", "Oppgave - krever kursholder"]) : singleton(["children", "Oppgave"]))))))))))),
                    })));
                }));
            })), ["children", reactApi_1.Children.toArray(Array.from(elems_7))])])));
        }, level.Tasks)))));
    })), ["children", reactApi.Children.toArray(Array.from(elems_8))])])));
}

function LevelAccordion(levelAccordionInputProps) {
    let elems_5, el_10, elems_4, el_8, elems_3, elems_2, elems_1, elems, el_4, el_6, props_16, name_6;
    const onTaskRevoke = levelAccordionInputProps.onTaskRevoke;
    const onTaskComplete = levelAccordionInputProps.onTaskComplete;
    const isInactive = levelAccordionInputProps.isInactive;
    const completedTasks = levelAccordionInputProps.completedTasks;
    const currentLevel = levelAccordionInputProps.currentLevel;
    const level = levelAccordionInputProps.level;
    const patternInput = reactApi.useState(empty_1());
    const setOpenItems = patternInput[1];
    const openItems = patternInput[0];
    const dependencies = [currentLevel];
    reactApi.useEffect(() => {
        if (exists((cl) => (cl.Id === level.Id), toArray(currentLevel))) {
            setOpenItems(singleton_1(1));
        }
    }, dependencies);
    const isCurrent = exists((cl_1) => (cl_1.Id === level.Id), toArray(currentLevel));
    const isCompleted = exists((cl_2) => (cl_2.Order > level.Order), toArray(currentLevel));
    const totalInLevel = getTasksInLevel(level);
    const completedInLevel = totalInLevel.filter((t) => isTaskCompleted(t, completedTasks));
    const allDone = (completedInLevel.length === totalInLevel.length) && (totalInLevel.length > 0);
    const el_12 = Accordion;
    return createElement(el_12, createObj(ofArray([["collapsible", true], ["openItems", Array.from(openItems)], ["defaultOpenItems", Array.from(openItems)], ["onToggle", (_arg_1, value_1_3) => {
        setOpenItems(ofArray(value_1_3.openItems));
    }], ["style", createObj(toList(delay(() => append_1(singleton(["display", "flex"]), delay(() => append_1(singleton(["width", 100 + "%"]), delay(() => (isCompleted ? append_1(singleton(["borderColor", tokens.colorStatusSuccessBackground2]), delay(() => append_1(singleton(["backgroundColor", tokens.colorStatusSuccessBackground1]), delay(() => append_1(singleton(["borderRadius", 4]), delay(() => append_1(singleton(["borderStyle", "solid"]), delay(() => singleton(["borderWidth", 1]))))))))) : (isCurrent ? append_1(singleton(["backgroundColor", tokens.colorNeutralBackground1]), delay(() => append_1(singleton(["borderColor", tokens.colorPaletteNavyBorderActive]), delay(() => append_1(singleton(["borderRadius", 4]), delay(() => append_1(singleton(["borderStyle", "solid"]), delay(() => singleton(["borderWidth", 2]))))))))) : empty())))))))))], (elems_5 = [(el_10 = AccordionItem, createElement(el_10, createObj(ofArray([["style", {
        flexGrow: 1,
        display: "flex",
        flexDirection: "column",
        width: 100 + "%",
    }], ["value", 1], (elems_4 = [(el_8 = AccordionHeader, createElement(el_8, createObj(ofArray([["style", {
        flexGrow: 1,
        display: "flex",
        width: 100 + "%",
    }], ["expandIconPosition", "end"], (elems_3 = [createElement("div", createObj(ofArray([["style", {
        alignItems: "center",
        flexGrow: 1,
        display: "flex",
        width: 100 + "%",
    }], (elems_2 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        width: 100 + "%",
    }], (elems_1 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        gap: 15 + "px ",
        alignItems: "center",
    }], (elems = toList(delay(() => {
        let el;
        return append_1(singleton((el = Body1Strong, createElement(el, {
            children: level.Name,
        }))), delay(() => {
            let el_2;
            return isCurrent ? singleton((el_2 = Badge, createElement(el_2, {
                children: "Ditt nivå",
                size: "small",
                appearance: "tint",
                style: {
                    backgroundColor: tokens.colorPaletteNavyBackground2,
                    color: tokens.colorPaletteNavyBorderActive,
                },
            }))) : empty();
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems))])]))), (el_4 = Caption1, createElement(el_4, {
        children: level.Description,
    }))], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), (el_6 = Badge, createElement(el_6, createObj(toList(delay(() => append_1(singleton(["size", "large"]), delay(() => append_1(singleton(["shape", "circular"]), delay(() => append_1(singleton(["appearance", "tint"]), delay(() => append_1((allDone && (currentLevel != null)) ? singleton(["color", "success"]) : singleton(["color", "informative"]), delay(() => singleton(["children", `${completedInLevel.length}/${totalInLevel.length}`]))))))))))))))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi_1.Children.toArray(Array.from(elems_3))])])))), (props_16 = singleton_1(createElement(LevelContent, {
        level: level,
        completedTasks: completedTasks,
        currentLevel: unwrap(currentLevel),
        isInactive: isInactive,
        onTaskComplete: unwrap(onTaskComplete),
        onTaskRevoke: unwrap(onTaskRevoke),
    })), (name_6 = AccordionPanel, createElement(name_6, {
        children: reactApi.Children.toArray(Array.from(props_16)),
    })))], ["children", reactApi_1.Children.toArray(Array.from(elems_4))])]))))], ["children", reactApi_1.Children.toArray(Array.from(elems_5))])])));
}

/**
 * Get stats for an enrolled track
 */
export function getTrackStats(track, completedTasks) {
    const levels = track.Track.TrackLevels;
    const allTasks = Array_distinct(collect(getTasksInLevel, levels), {
        Equals: equals,
        GetHashCode: safeHash,
    });
    let completedTaskCount;
    const array_3 = allTasks.filter((t) => isTaskCompleted(t, completedTasks));
    completedTaskCount = array_3.length;
    let completedLevelCount;
    const array_5 = levels.filter((l) => isLevelCompleted(l, completedTasks));
    completedLevelCount = array_5.length;
    const pct = ((allTasks.length === 0) ? 0 : ~~((completedTaskCount / allTasks.length) * 100)) | 0;
    const TotalLevels = levels.length | 0;
    const TotalTasks = allTasks.length | 0;
    return {
        CompletedLevels: completedLevelCount,
        CompletedTasks: completedTaskCount,
        CurrentLevel: unwrap(getCurrentLevel(track.Track, track.CurrentTrackLevelId)),
        Percentage: pct,
        TotalLevels: TotalLevels,
        TotalTasks: TotalTasks,
    };
}

export function TrackProgress(props) {
    let elems_3, elems_2;
    const track = props.Track.Track;
    const currentLevel = getCurrentLevel(track, props.Track.CurrentTrackLevelId);
    const levels = sortBy((_arg) => _arg.Order, track.TrackLevels, {
        Compare: comparePrimitives,
    });
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 10 + "px ",
    }], (elems_3 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        width: 100 + "%",
    }], (elems_2 = toList(delay(() => mapIndexed((idx, level) => {
        let elems_1, elems;
        const isLast = (idx + 1) === levels.length;
        return createElement("div", createObj(ofArray([["key", level.Id], ["style", {
            width: 100 + "%",
            display: "flex",
            flexDirection: "row",
            gap: 15 + "px ",
            paddingBottom: 15,
        }], (elems_1 = [createElement("div", createObj(ofArray([["style", {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
        }], (elems = toList(delay(() => {
            let cl_2, el, cl_3, el_2, el_4;
            return (currentLevel != null) ? ((currentLevel.Id === level.Id) ? ((cl_2 = currentLevel, append_1(singleton((el = CircleHintHalfVerticalFilled, createElement(el, {
                fontSize: 24,
                primaryFill: tokens.colorPaletteNavyBorderActive,
            }))), delay(() => (!isLast ? singleton(customDivider(tokens.colorPaletteNavyBorderActive)) : empty()))))) : ((currentLevel.Order > level.Order) ? ((cl_3 = currentLevel, append_1(singleton((el_2 = CheckmarkCircleFilled, createElement(el_2, {
                fontSize: 24,
                primaryFill: tokens.colorStatusSuccessBorderActive,
            }))), delay(() => (!isLast ? singleton(customDivider(tokens.colorStatusSuccessBorderActive)) : empty()))))) : append_1(singleton((el_4 = LockClosedRegular, createElement(el_4, {
                fontSize: 24,
            }))), delay(() => (!isLast ? singleton(customDivider(tokens.colorNeutralForegroundDisabled)) : empty()))))) : append_1(singleton((el_4 = LockClosedRegular, createElement(el_4, {
                fontSize: 24,
            }))), delay(() => (!isLast ? singleton(customDivider(tokens.colorNeutralForegroundDisabled)) : empty())));
        })), ["children", reactApi.Children.toArray(Array.from(elems))])]))), createElement(LevelAccordion, {
            level: level,
            currentLevel: unwrap(currentLevel),
            completedTasks: props.CompletedTasks,
            isInactive: props.IsInactive,
            onTaskComplete: unwrap(props.OnTaskComplete),
            onTaskRevoke: unwrap(props.OnTaskRevoke),
        })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
    }, levels))), ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
}

//# sourceMappingURL=TrackProgress.jsx.map
